exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".photos{position:relative;padding:24px 0}.vue-dropzone~label{font-size:.85em;z-index:0;opacity:.5;position:absolute;top:0;left:0}.vue-dropzone{padding:15px!important;margin-bottom:1rem}.vue-dropzone .dz-preview{margin:0 1rem 1rem 0;width:25%!important}.dz-custom-image-preview{width:10rem;display:inline-block}.ql-editor ul{padding-left:0}.fineprint label,.what-you-get label{font-size:.85em}.fineprint span,.what-you-get span{text-decoration:underline;-webkit-text-decoration-style:dotted;text-decoration-style:dotted}.fineprint span:hover,.what-you-get span:hover{text-decoration:underline;cursor:pointer}.copy-link span{opacity:.8}.md-input.quantity{width:25%}.remaining,.sold{font-size:.85em;opacity:.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1dcdd20b","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/franchise_component/inventory/coupon/vuetablecoupon_form.vue
// module id = QCVD
// module chunks = 86